import { Col, Form, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

export const CaseSymptomsCard = () => {
  const { t } = useLocales()

  return (
    <Col span={24}>
      <Form.Item
        name={['form', 'symptoms', 'caseType', 'status']}
        rules={requiredRules}
        label={`12. ${t('epidemiology.case')}`}
      >
        <Radio.Group>
          <Radio value="singleCase">Caz izolat</Radio>
          <Radio value="outbreakCase">Caz de izbucnire</Radio>
        </Radio.Group>
      </Form.Item>
    </Col>
  )
}
